import toast from 'react-hot-toast'
import Facebook from "../assets/images/facebook.svg";
import Instagram from "../assets/images/instagram.svg";
import Twitter from "../assets/images/twitter.svg";
import Youtube from "../assets/images/youtube.svg";
import Linkedin from "../assets/images/linkedin.svg";

export const employmentOptions = ['Student', 'Employed', 'Unemployed', 'Self employed', 'Retired']
export const genderOptions = ['Male', 'Female']
export const idTypeOptions = [
  `National Identification Number (NIN)`,
  `Residence/Work Permit (For Foreigners)`,
  `Permanent Voter's Card`,
  `Driver's license`,
  `International Passport`,
]


export const educationLevelOptions = [
  "Primary School",
  "Senior Secondary School",
  "National Certificate of Education (NCE)",
  "Ordinary Diploma ",
  "Higher National Diploma (HND)",
  "Bachelor’s Degree",
  "Masters",
  "Post Graduate Degree (PGD)",
  "Doctorate (PHD)",
]

export const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export const countries = ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antigua and Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","British Virgin Islands","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Cape Verde","Cayman Islands","Chad","Chile","China","Colombia","Congo","Cook Islands","Costa Rica","Cote D Ivoire","Croatia","Cruise Ship","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Estonia","Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Polynesia","French West Indies","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guam","Guatemala","Guernsey","Guinea","Guinea Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kuwait","Kyrgyz Republic","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Mauritania","Mauritius","Mexico","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Namibia","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Norway","Oman","Pakistan","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russia","Rwanda","Saint Pierre and Miquelon","Samoa","San Marino","Satellite","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","South Africa","South Korea","Spain","Sri Lanka","St Kitts and Nevis","St Lucia","St Vincent","St. Lucia","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor L'Este","Togo","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Turks and Caicos","Uganda","Ukraine","United Arab Emirates","United Kingdom","Uruguay","Uzbekistan","Venezuela","Vietnam","Virgin Islands (US)","Yemen","Zambia","Zimbabwe"];
export const nigeriaStates = [
  "Abia",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "FCT - Abuja",
  "Gombe",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Taraba",
  "Yobe",
  "Zamfara"
];

export const social = [
  {icon: Facebook, path: 'https://web.facebook.com/Worknation-100423836232607'},
  {icon: Instagram, path: 'https://www.instagram.com/worknationng'},
  {icon: Twitter, path: 'https://twitter.com/WorknationNG'},
  {
    icon: Youtube,
    path: 'https://www.youtube.com/channel/UCTZ0d3nAeEtHwtq_ADARlzg',
  },
  {
    icon: Linkedin,
    path: 'https://www.linkedin.com/company/worknation',
  },
]

export const formatNumber = number => {
  if (!number) return 0
  return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const formatCurrency = value => {
  if (!value) return 0
  const number = parseInt(value.replace(/,/g, ''));
  const formattedValue = new Intl.NumberFormat("en-US").format(number); // Format the input value as currency

  return formattedValue
}

export const TestPromptText = (test = "career path")=>{
  return `Thank you for choosing WorkNation. You’re about to begin the ${test} tests. Please note  that The test results are only a reflection of your foundation knowledge and will help us profile you for further training. Also, each career path test is timed so be quick with your responses as the test will automatically end once the timer counts down.`
}
export const CultureFitPromptText = `Thank you for choosing WorkNation. You’re about to begin the culture fit tests. Please note  that the test result is only a reflection of your foundation knowledge and will help us profile you for further training. Also, the test is timed so be quick with your responses as the test will automatically end once the timer counts down.`

export const success_notify = (str) => toast.success(str)
export const loading_notify = (str) => toast.loading(str)
export const fail_notify = (str) => toast.error(str)
export const submit_success = (str) => toast.success(str)

export const sortTable = (tableId, n) => {
  let table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
  table = document.getElementById(tableId);
  switching = true;
  // Set the sorting direction to ascending:
  dir = "asc";
  /* Make a loop that will continue until
  no switching has been done: */
  while (switching) {
    // Start by saying: no switching is done:
    switching = false;
    rows = table.rows;
    /* Loop through all table rows (except the
    first, which contains table headers): */
    for (i = 1; i < (rows.length - 1); i++) {
      // Start by saying there should be no switching:
      shouldSwitch = false;
      /* Get the two elements you want to compare,
      one from current row and one from the next: */
      x = rows[i].getElementsByTagName("TD")[n];
      y = rows[i + 1].getElementsByTagName("TD")[n];
      /* Check if the two rows should switch place,
      based on the direction, asc or desc: */
      if (n === 6) {
        if (dir === "asc") {
          if (+x.innerHTML.slice(0, -1) > +y.innerHTML.slice(0, -1)) {
            // If so, mark as a switch and break the loop:
            shouldSwitch = true;
            break;
          }
        } else if (dir === "desc") {
          if (+x.innerHTML.slice(0, -1) < +y.innerHTML.slice(0, -1)) {
            // If so, mark as a switch and break the loop:
            shouldSwitch = true;
            break;
          }
        }
      } else {
        if (dir === "asc") {
          if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
            // If so, mark as a switch and break the loop:
            shouldSwitch = true;
            break;
          }
        } else if (dir === "desc") {
          if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
            // If so, mark as a switch and break the loop:
            shouldSwitch = true;
            break;
          }
        }
      }

    }
    if (shouldSwitch) {
      /* If a switch has been marked, make the switch
      and mark that a switch has been done: */
      rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
      switching = true;
      // Each time a switch is done, increase this count by 1:
      switchcount ++;
    } else {
      /* If no switching has been done AND the direction is "asc",
      set the direction to "desc" and run the while loop again. */
      if (switchcount === 0 && dir === "asc") {
        dir = "desc";
        switching = true;
      }
    }
  }
}

export const removeFields = (obj, fieldsToRemove) => {
  for (let field of fieldsToRemove) {
    delete obj[field];
  }
}

export const timeFormat = (dateTimeString) => {
  const dateTime = new Date(dateTimeString);

  // Format the date and time
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true // Use 12-hour clock
  };

  return dateTime.toLocaleString("en-US", options);
}
